import React from 'react';
export default class Round extends React.Component {
    render() {
        const { className, style, color } = this.props;
        const defaultStyles = {
            backgroundColor: color,
            borderRadius: '50%',
            width: 80,
            height: 80
        };
        const classes = ['cl-round-shape', className].filter(c => c).join(' ');
        return React.createElement("div", { className: classes, style: Object.assign(Object.assign({}, defaultStyles), style) });
    }
}
Round.defaultProps = {
    color: '#ccc'
};
